import React from 'react'
import { Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"


export default function SubMenuTitles({ seccion, usertype, candidateId }) {
    const { t } = useTranslation()

    return (    
        <Nav defaultActiveKey="/candidate/profile/officialtitles" className="flex-column submenu">
            <Nav.Item>
                <Link
                    to={usertype === 'Superadmin' ? '/admin/candidate/officialtitles/'+candidateId : '/candidate/profile/officialtitles'}
                    className={`nav-link ${seccion === 'official' ? 'active' : ''}`}
                >
                    <img src="/images/menus/titulosoficiales.svg" alt="Titulos oficiales" className='me-3'/>
                    {t('profile.candidate.officialTitles')}
                </Link>
            </Nav.Item>
            <Nav.Item>
                <Link
                    to={usertype === 'Superadmin' ? '/admin/candidate/courses/'+candidateId : '/candidate/profile/courses'}
                    className={`nav-link ${seccion === 'courses' ? 'active' : ''}`}
                >
                    <img src="/images/menus/cursos.svg" alt="Cursos" className='me-3'/>
                    {t('profile.candidate.courses')}
                </Link>
            </Nav.Item>
        </Nav>
    )
}